// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/rows-2.js';

import { paths } from '../generated/rows-2';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('rows-2', Original, paths);
